import styled from '@mui/material/styles/styled';
import Box from '@mui/material/Box';

export const Root = styled(Box)({
  position: 'relative',
  width: 260,
  height: 170,
  marginBottom: 5
});

export const Info = styled(Box)({
  position: 'absolute',
  bottom: 0, right: 0, left: 0,
  height: 45,
  background: 'rgba(0,0,0,.6)',
  display: 'flex',
  gap: '4px',
  padding: 12,
});

export const DocPlaceholder = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#f4f4f8',
  cursor: 'pointer',
  paddingBottom: 45,
  '& > *': {
    maxHeight: 36,
  }
}));